export default "__VITE_ASSET__DN0gNfmG__"